import React, {Component} from 'react';
import PropTypes from 'prop-types';

class RowsCountSelect extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    if (this.props.onElementsCount) {
      this.props.onElementsCount(e.target.value);
    }
  }

  render() {
    return (
      <div className={`form-group`} id={`${this.props.tableId}_length`}>
        <select
          name="checkins_table_length"
          aria-controls={this.props.tableId}
          onChange={this.onChange}
          className="form-control"
          value={this.props.elementsCount}
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    );
  }
}

RowsCountSelect.propTypes = {
  tableId: PropTypes.string,
  onElementsCount: PropTypes.func,
  elementsCount: PropTypes.any,
  columnCount: PropTypes.number,
};

export default RowsCountSelect;
